import { OwaDate, getDateString } from 'owa-datetime';
import recurrenceType from 'owa-service/lib/factory/recurrenceType';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import endDateRecurrence from 'owa-service/lib/factory/endDateRecurrence';
import noEndRecurrence from 'owa-service/lib/factory/noEndRecurrence';

export default function updateRecurrenceEnd(
    recurrence: RecurrenceType,
    endDate: OwaDate | null
): RecurrenceType {
    const { RecurrencePattern } = recurrence;
    const { StartDate } = recurrence.RecurrenceRange;

    // NOTE: EWS only seems to work correclty if the recurrence does not
    // have the offset AND if the time zone header matches the StartTimeZoneId.
    const RecurrenceRange = endDate
        ? endDateRecurrence({ StartDate, EndDate: getDateString(endDate) })
        : noEndRecurrence({ StartDate });

    return recurrenceType({ RecurrencePattern, RecurrenceRange });
}
